import React from 'react';

import styles from './modelContext.module.scss';

type Props = {
  disabled: boolean;
  onPromptChange: ( value: string ) => void;
  onTemperatureChange: ( value: number ) => void;
  prompt: string;
  temperature: number;
};

const ModelContext = ( {
  disabled,
  onPromptChange,
  onTemperatureChange,
  prompt,
  temperature
}: Props ) => {
  return (
    <>
      <span className={ styles.item } >
        <label htmlFor='prompt'>Prompt { disabled && '(locked)' }</label>
        <textarea
          disabled={ disabled }
          id='prompt'
          onChange={ e => onPromptChange( e.currentTarget.value ) }
          value={ prompt }
        />
      </span>

      <span className={ styles.item } >
        <label htmlFor='temperature'>Temperature: { temperature || 'default' } { disabled && '(locked)' }</label>
        <input
          disabled={ disabled }
          id='temperature'
          max='1'
          min='0'
          onChange={ e => onTemperatureChange( Number( e.target.value ) ) }
          step='0.1'
          type='range'
          value={ temperature || 0 }
        />
      </span>
    </>
  );
};

export default ModelContext;
